import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63fb4e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "Online Store", -1 /* HOISTED */))

import SearchBar from './SearchBar.vue';
import CartLink from './CartLink.vue';

import { RouteNames } from '@/router';
import { useSearch } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { searchField, startSearch } = useSearch([
  'title',
  'description',
  'brand',
  'price',
  'stock',
  'category',
  'rating',
  'actualPrice',
]);

function click() {
  startSearch();
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      class: "a",
      to: { name: _unref(RouteNames).productSearch }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    _createVNode(SearchBar, {
      onSearch: click,
      modelValue: _unref(searchField),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchField) ? (searchField).value = $event : null))
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createVNode(CartLink)
  ]))
}
}

})